// @ts-nocheck

import { request } from '../../../../../context';
import type { ApiOptions } from '../../../../../context';
import type {
    PostLocalInspectRecordUploadTicketBody,
    BaseResponseVoid,
} from '../../../../../types';

/**
 * 上传质检任务
 *
 * @export
 * @tags local-upload-inspect-controller
 * @link [POST] /local/inspect/record/upload/ticket
 */
export function postLocalInspectRecordUploadTicket(
    data: PostLocalInspectRecordUploadTicketBody
): Promise<BaseResponseVoid>;
export function postLocalInspectRecordUploadTicket(
    data: PostLocalInspectRecordUploadTicketBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postLocalInspectRecordUploadTicket(
    data: PostLocalInspectRecordUploadTicketBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostLocalInspectRecordUploadTicketBody, never, never>(
        '/local/inspect/record/upload/ticket',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postLocalInspectRecordUploadTicket',
        }
    );
}

export const meta = [
    {
        tags: ['local-upload-inspect-controller'],
        path: '/local/inspect/record/upload/ticket',
        method: 'post',
    },
];
